import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { getProgramTitle, RhinoEPGProgram } from '@kaltura-ott/tvpil-shared';

interface Props {
  program: RhinoEPGProgram;
  isRestrictedByAdult: boolean | undefined;
  isCatchUp: boolean | undefined;
  isCatchUpWithNoData: boolean;
  isAdultCathUpPlaybackEnabled: boolean;
}

export function useResolveTitle({
  isCatchUp,
  program,
  isRestrictedByAdult,
  isCatchUpWithNoData,
  isAdultCathUpPlaybackEnabled,
}: Props) {
  const intl = useIntl();
  return useMemo(() => {
    if (program.isPlaceholder) {
      return ''
    }

    let title = getProgramTitle(program);

    if (isRestrictedByAdult) {
      title = intl.formatMessage({ id: 'Epg.ProgramCard.restrictedContent', defaultMessage: 'Restricted Content' });
    }

    if (program.isNotFound) {
      if (!isRestrictedByAdult) {
        title = intl.formatMessage({
          id: 'Epg.ProgramCard.noDataAvailable',
          defaultMessage: 'Program cannot be played or no data available',
        });
      }

      if (isCatchUp) {
        title = intl.formatMessage({
          id: 'Epg.ProgramCard.noDataCatchUp',
          defaultMessage: 'This Channel Does Not Show Past Programs',
        });
      }
    } else if ((program.isAdult && isCatchUp && !isAdultCathUpPlaybackEnabled) || isCatchUpWithNoData) {
      title = intl.formatMessage({
        id: 'Epg.ProgramCard.noDataCatchUp',
        defaultMessage: 'This Channel Does Not Show Past Programs',
      });
    }

    return title;
  }, [program.id, isRestrictedByAdult, isCatchUp]);
}
